export function getBackendUrl() {
  return process.env.REACT_APP_BE_URL ?? "https://bizservice.expensehut.com";
}

export function getAuthUrl() {
  return process.env.REACT_APP_AUTH_BE_URL ?? "https://auth.expensehut.com";
}
